import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdLaunchValidation =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/launch_validation";

export const decisioningStudioAgentsAppGroupIdDsaIdLaunchValidationCacheKeys: AllRouteEndpoints[] = [
  "/decisioning_studio_agents/:app_group_id/:dsa_id/launch_validation",
];
